// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3qvhW","title":"AfterFrontImage_title__2MurW"};